import React, { Suspense } from 'react';
import { CardBody, Row, Col, Button, Label, FormGroup } from "reactstrap";
import Cards from '../Components/Cards';
import { Progress } from 'reactstrap';
import { Services } from './Services'
import '../cards.scss'
import axios from 'axios';
import { Pagination } from 'semantic-ui-react';
import { Menu, Segment, Sidebar } from 'semantic-ui-react';
import Form from '../Components/Maps/models/index'
import { withRouter } from 'react-router-dom';
import ClientesList from '../../../services/storageClient.js';
import Loader from './../../Global/Loader/index'
import ContentWrapper from '../../template/Layout/ContentWrapper';


const Map = React.lazy(() => import('../Components/Maps/map'));
const clientSave = new ClientesList();

class ShipmentTracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: [
        { title: 'Shipment No', xls: true, header: { link: false, hide: true, icon: false }, data: { link: false, progress: false, icon: false, status: false, hide: true }, id: 'ShipmentId', className: 'hidden' },
        { title: 'Transport Mode', xls: true, header: { link: false, hide: true, icon: false }, data: { link: false, progress: false, icon: false, status: false, hide: true }, id: 'TransportMode', className: 'hidden' },
        { title: 'Status', xls: true, foot: { show: false, style: { fontSize: '12px', fontWeight: 'bold' } }, header: { link: false, hide: true, icon: false }, data: { link: false, progress: false, icon: false, status: false, }, id: 'Estatus', link: '/shipmentsDetal/', className: 'col-md-3 col-lg-2 col-sm-6' },
        { title: 'Supplier', xls: true, foot: { show: false, style: { fontSize: '12px', fontWeight: 'bold', color: 'green' } }, data: { link: false, progress: false, icon: false, status: false }, header: { link: false }, id: 'SupplierName', link: '/shipmentsDetal/', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'Consignee', xls: true, icon: 'fa-2x mr-2 fas fa-arrow-alt-circle-left', colorLogo: '#643296c2', id: 'ConsigneeName', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'Customer Reference', xls: true, foot: { show: false, style: { fontSize: '12px', fontWeight: 'bold', color: 'green' } }, data: { link: false, progress: false, icon: false, status: false }, header: { link: false }, id: 'ClientRef', link: '/shipmentsDetal/', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'Container', xls: true, foot: { show: false, style: { fontSize: '12px', fontWeight: 'bold', color: 'green' } }, data: { link: false, progress: false, icon: false, status: false }, header: { link: false }, id: 'NoContainer', link: '/shipmentsDetal/', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'From', xls: true, link: '/shipmentsDetal/', id: 'POL', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'To', xls: true, data: { link: false, progress: false, icon: false, status: false }, link: '/shipmentsDetal/', id: 'POD', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'ETD', xls: true, data: { link: false, progress: false, icon: false, status: false }, id: 'ETD', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'ETA', xls: true, data: { link: false, progress: false, icon: false, status: false }, link: '/shipmentsDetal/', id: 'ETA', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'ATD', xls: true, data: { link: false, progress: false, icon: false, status: false }, id: 'ATD', className: 'col-md-3 col-lg-1 col-sm-6' },
        { title: 'ATA', xls: true, data: { link: false, progress: false, icon: false, status: false }, link: '/shipmentsDetal/', id: 'ATA', className: 'col-md-3 col-lg-1 col-sm-6' },
      ],
      advancedSearch: [
        {
          title: 'Shipment information',
          data: [
            [
              {
                title: 'Shipment No.', type: 'text', id: 'ShipmentNumber', class: 'col-3', values: [], value: ''
              },
              {
                title: 'Transport Mode', type: 'select', id: 'TransportMode', class: 'col-3', values: [], value: ''
              },
              {
                title: 'Status', type: 'select', id: 'Estatus', class: 'col-3', values: [], value: ''
              },
              {
                title: 'Customer Reference', type: 'text', id: 'ClientRef', class: 'col-3', values: [], value: ''
              },
            ],
            [
              {
                title: 'Container No.', type: 'text', id: 'NoContainer', class: 'col-3', values: [], value: ''
              },
              {
                title: 'HBL', type: 'text', id: 'HBL_HAWB', class: 'col-3', values: [], value: ''
              },
              {
                title: 'MBL', type: 'text', id: 'MBL_AWB', class: 'col-3', values: [], value: ''
              },
              {
                title: 'Supplier Name', type: 'text', id: 'SupplierName', class: 'col-3', values: [], value: ''
              },
            ],
            [
              {
                title: 'Consignee Name', type: 'text', id: 'ConsigneeName', class: 'col-3', values: [], value: ''
              },
              {
                title: 'Delivery', type: 'text', id: 'Delivery', class: 'col-3', values: [], value: ''
              },
              {
                title: 'From', type: 'select', id: 'POL', class: 'col-3', values: [], value: ''

              },
              {
                title: 'To', type: 'select', id: 'POD', class: 'col-3', values: [], value: ''
              }
            ],
            [
              {
                title: 'Incoterm', type: 'text', id: 'Incoterm', class: 'col-3', values: [], value: ''
              },
              {
                title: 'Traffic', type: 'select', id: 'Traffic', class: 'col-3', values: [], value: ''
              },
            ]
          ]
        },
        {
          data: [
            [
              {
                title: 'Shipment Creation', type: 'dateRange', id: 'ShipmentDate', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'Booking Request', type: 'dateRange', id: 'BookingRequestDate', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'ETD', type: 'dateRange', id: 'ETD', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'ETA', type: 'dateRange', id: 'ETA', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'ATD', type: 'dateRange', id: 'ATD', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'ATA', type: 'dateRange', id: 'ATA', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'Delivery at Destination', type: 'dateRange', id: 'DeliveryAtDestination', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
              {
                title: 'Invoicing', type: 'dateRange', id: 'Invoicing', class: 'col-6', values: [], value: '', date: { init: '', end: '' }
              },
            ],
          ]
        }
      ],
      clientesSelect: clientSave.getAuthentication('client'),
      map:
        <Suspense fallback={<div>Loading...</div>}>
          <Map
            heidIcon={30}
            style={{ maxHeight: '300px' }}
            marker={[]}
            visible={true}
            type={'polylineDrawer'}
            // data={polyline}
            dataDrawer={''}
            zoom={3}
            reset={true}
          />
        </Suspense>,
      reset: true,
      activePage: 1,
      limit: 10,
      paramsxml: {},
      numberPage: 1,
      totalPages: 1,
      search: '',
      isSearch: false,
      totalCard: [],
      dataDrawer: '',
      visible: false,
      selected: '',
      polyline: [],
      data: [],
      // dataMap: mapJson.dataMap,
      dataAux: [],
      dataOut: [],
      labelStatus: 'closed',
      loading: true,
      loaderMap: false,
      graphs: [],
      markers: [],
      dataMap: [],
      url: '',
      advancedObj: [],
      showDrawerInfo: false,
      fullLoader: false,
      id: ''
    };
  }

  componentDidMount = () => {
    this.getListShipments();
    this.getDataMap();
    this.getCatalogs();

    // this.buildOverlay()
  }




  getCatalogs = () => {
    let data = {
      client: this.state.clientesSelect,
    };
    axios.post(`${Services.Get_Traceability_Shipments.path}shipments/catalogShipment`, data).then(success => {
      let ModoTransporte = success.data.data.ModoTransporte.map(e => { return { value: e.TransportMode, label: e.TransportMode ? e.TransportMode : 'No Transport Mode' }; });
      let Estatus = success.data.data.Estatus.map(e => { return { value: e.Estatus, label: e.Estatus ? e.Estatus : 'No value' }; });
      let Traffic = success.data.data.Traffic.map(e => { return { value: e.Traffic, label: e.Traffic ? e.Traffic : 'No value' }; });
      let POD = success.data.data.POD.map(e => { return { value: e.POD, label: e.POD ? e.POD : 'No value' }; });
      let POL = success.data.data.POL.map(e => { return { value: e.POL, label: e.POL ? e.POL : 'No value' }; });

      let newAdvanced = this.state.advancedSearch;
      newAdvanced.map(e => {
        e.data.map(f => {
          f.map(g => {
            if (g.id === 'TransportMode') {
              g.values = ModoTransporte;
            }
            if (g.id === 'Estatus') {
              g.values = Estatus;
            }
            if (g.id === 'Traffic') {
              g.values = Traffic;
            }
            if (g.id === 'POD') {
              g.values = POD;
            }
            if (g.id === 'POL') {
              g.values = POL;
            }
            return g;
          });
          return f;
        });
        return e;
      });
      this.setState({
        advancedSearch: newAdvanced
      });
    }).catch(error => {
      console.warn(error);
    });
  }

  buildOverlay = (x) => {
    let OverlayData = Form.Overlay.map((e, key) => {
      if (e.type === 'Tittle') {
        return (
          <>
            <div className='col-md-6' key={key} style={{ textAlign: 'left', fontSize: '12px', fontFamily: 'Montserrat,Helvetica Neue,Arial,sans-serif' }}>
              <FormGroup>
                <Col>
                </Col>
                <Label style={{ color: '#656565' }} >
                  <i className={x.TransportMode === 'InLand' && e.label === 'ETD' ? '' : x.TransportMode === 'InLand' && e.label === 'ETA' ? '' : e.ico} style={{ color: '#005e97' }} />
                  <b>{x.TransportMode === 'InLand' && e.label === 'ETD'
                    ? ''
                    : x.TransportMode === 'InLand' && e.label === 'ETA'
                      ? ''
                      : x.TransportMode === 'InLand' && e.label === 'ATD'
                        ? e.labelTe
                        : x.TransportMode === 'InLand' && e.label === 'ATA'
                          ? e.labelTe
                          : e.label}</b>
                </Label>
                <Label>
                  {x.TransportMode === 'InLand' && e.label === 'ETD'
                    ? ''
                    : x.TransportMode === 'InLand' && e.label === 'ETA'
                      ? ''
                      : x[x.TransportMode === 'InLand' && e.labelTe === 'PickUp' ? e.idTe : e.id]}
                </Label>
              </FormGroup>
            </div>
          </>
        )
      }
      else if (e.type === 'Status') {
        return (
          <div className='col-md-6' style={{ textAlign: 'left', fontSize: '12px', fontFamily: 'Montserrat,Helvetica Neue,Arial,sans-serif' }}>
            <FormGroup>
              <i className={x.ModoTransporte === "MARITIMA" ? 'fas fa-ship mr-2' : x.ModoTransporte === "AEREA" ? 'fas fa-plane mr-2' : 'fas fa-truck mr-2'} style={{ fontSize: '3em', color: '#005e97' }}></i>
              <b>{x[e.id]}</b>
              <Label>
                {x[e.number]}
              </Label>
            </FormGroup>
          </div>
        )
      }
      else if (e.type === 'Time') {
        return (
          <div className='col-md-6'>
            <FormGroup>
              <span style={{ color: 'green' }}>On Time</span>
              <Progress color={'success'} value={x[e.id]} />
            </FormGroup>
          </div>
        )
      }
      else return (<hr></hr>)
    })
    this.setState({
      OverlayData,
      id: x.ShipmentId
    })
  }


  setAdvanced = (val) => {
    this.setState({ advancedObj: val }, () => { this.getListShipments(); });
  }

  getListShipments = () => {

    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      search: this.state.search,
      advanced: this.state.advancedObj,
    };
    this.setState({ url: encodeURI(`${Services.Get_Shipment.path}shipments/all?search=${this.state.search}&allData=true`), paramsxml: data });
    // axios.post(`${Services.Get_Traceability_Shipments.Path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {
    axios.post(`${Services.Get_Shipment.path}shipments/all`, data).then(success => {
      let data = success.data.data.map((e) => {
        let TraspormodeId = 1;
        e.TraspormodeId = TraspormodeId;
        return e;
      });

      console.log('data-->', data);
      this.setState({
        totalPages: success.data.totalPage,
        data: data,
        loading: false
      });
    }).catch(error => {
      console.warn(error);
      this.setState({
        loading: false
      })
    });
  };


  getDataMap = async () => {
    try {
      const data = {
        client: this.state.clientesSelect
      };

      const response = await axios.post(
        `${Services.Get_DataMap.path}shipments/dataMap`,
        data
      );

      const shipments = response.data.data || [];

      const markers = [];
      const polyline = [];

      const getIcon = (modo) => {
        switch (modo) {
          case 'AEREA':
            return 'https://fsposeidon.blob.core.windows.net/files/airplane (1).png';
          case 'MARITIMA':
            return 'https://fsposeidon.blob.core.windows.net/files/cruise-poseidon.png';
          default:
            return 'https://fsposeidon.blob.core.windows.net/magicvisionpic/truck.png';
        }
      };

      shipments.forEach((s, index) => {
        const icon = getIcon(s.ModoTransporte);

        if (s.OriginLatitud && s.OriginLongitude) {
          markers.push({
            title: 'Origin',
            name: s.ShipmentId,
            data: s,
            position: {
              lat: Number(s.OriginLatitud),
              lng: Number(s.OriginLongitude)
            },
            icon: { url: icon }
          });

          polyline.push({
            lat: Number(s.OriginLatitud),
            lng: Number(s.OriginLongitude)
          });
        }

        if (s.destinationLatitud && s.destinationLongitude) {
          markers.push({
            title: 'Destination',
            name: s.ShipmentId,
            data: s,
            position: {
              lat: Number(s.destinationLatitud),
              lng: Number(s.destinationLongitude)
            },
            icon: { url: icon }
          });

          polyline.push({
            lat: Number(s.destinationLatitud),
            lng: Number(s.destinationLongitude)
          });
        }
      });

      this.setState(
        {
          loaderMap: true,
          markers,
          polyline,
          reset: false
        },
        () => {
          this.setState({
            map: (
              <Suspense fallback={<div>Loading...</div>}>
                <Map
                  toggleDrawer={this.toggleDrawerMap2}
                  heidIcon={30}
                  style={{ maxHeight: '300px' }}
                  marker={markers}
                  visible={true}
                  dataDrawer={this.state.dataDrawer}
                  type={"polylineDrawer"}
                  zoom={3}
                  reset={false}
                />
              </Suspense>
            )
          });
        }
      );
    } catch (error) {
      console.warn(error);
    }
  };

  changePage = page => {
    this.setState({
      numberPage: page,
      activePage: page
    }, () => {
      this.getListShipments();
    });
  }


  handleChange = () => event => {
    let val = event.target.value;
    if (!this.state.isSearch) {
      this.setState({ isSearch: true }, () => {
        this.setState({
          search: val, activePage: 1,
          limit: 10,
          numberPage: 1,
          totalPages: 1
        }, () => { this.getListShipments(); });
      });
    }
  }

  newSearch = (val) => {

    if (val.length < 1) {
      this.setState({
        search: val, isSearch: false, activePage: 1, limit: 10,
        numberPage: 1,
        totalPages: 1
      }, () => { this.getListShipments(); });
    }
    else {
      if (val.length < this.state.search.length) {
        this.setState({
          search: val, activePage: 1, limit: 10,
          numberPage: 1,
          totalPages: 1
        }, () => { this.getListShipments(); });
      }
      else {
        this.setState({ search: val }, () => { this.getListShipments(); });
      }
    }
  }


  polyLine = (data) => {
    if (data.OriginLatitud && data.destinationLatitud) {
      let polyline = [
        { lat: parseFloat(data.OriginLatitud), lng: parseFloat(data.OriginLongitude) },
        { lat: parseFloat(data.destinationLatitud), lng: parseFloat(data.destinationLongitude) }
      ];
      this.setState({
        polyline: polyline
      }, () => {
        this.setState({
          map:
            <Suspense fallback={<div>Loading...</div>}>
              <Map
                zoom={3}
                polyline={polyline}
                toggleDrawer={this.toggleDrawerMap2}
              />
            </Suspense>
        })
      });
    };
  }



  toggleDrawerMap = data => evt => {
    this.buildOverlay(data)
    this.setState({
      visible: true,
      // dataDrawer: data,
      showDrawerInfo: true,
      dataMapId: data
    })
    this.polyLine(data)
  };

  toggleDrawerMap2 = data => {
    this.buildOverlay(data)
    this.setState({
      visible: true,
      // dataDrawer: data,
      showDrawerInfo: true,
      dataMapId: data
    })
  };

  backres = (backResponse) => {
    this.setState({
      data: backResponse,
      dataAux: backResponse,
      dataOut: backResponse,
    });
  }
  render() {
    let { url, labelStatus, data, totalPages, activePage, id, loaderMap } = this.state;
    return (
      <>
        <Loader hidden={loaderMap}></Loader>
        <ContentWrapper>
          <div className="content-heading">
            <i className='fas fa-map-marker-alt mr-2'></i>
            <b>Shipments Tracking</b>
          </div>
          <div>
            <Sidebar.Pushable>
              <Sidebar
                as={Menu}
                animation='uncover'
                icon='labeled'
                vertical
                visible={this.state.showDrawerInfo}
                width='wide'
                direction={'right'}
              >
                <Menu.Item as='a' onClick={() => { this.setState({ showDrawerInfo: false }); }}>
                  <b>Close</b>
                </Menu.Item>
                <CardBody>
                  <Row>
                    {this.state.OverlayData}
                  </Row>
                </CardBody>
                <div className="col-12" style={{ textAlign: 'center' }}>
                  <Button color="primary" style={{ borderRadius: '16px' }} onClick={() => { this.props.history.push('/shipmentsDetail/' + id); }}>View Details</Button>
                </div>
              </Sidebar>
              <Sidebar.Pusher>
                <Segment>
                  {this.state.map}
                </Segment>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </div>
          <div>
            <Cards paramsxml={this.state.paramsxml} clientesSelect={this.state.clientesSelect} advancedSearch={(val) => { this.setAdvanced(val); }} advancedSearchData={this.state.advancedSearch} urlReport={url} newSearch={(value) => { this.newSearch(value); }} pagination={false} broswer={true} config={this.state.config} headerCard={this.state.headerCard} toggleDrawer={this.toggleDrawerMap} visible={this.state.visible} data={data} reset={this.resetTableCards} labelStatus={labelStatus} backRes={this.backres}></Cards>
            {/* <Cards config={this.state.config} data={data} dataSearch={data}></Cards> */}
            <Row className="justify-content-center">
              <Pagination
                activePage={activePage}
                // ellipsisItem={null}
                totalPages={totalPages}
                onPageChange={(e, { activePage }) => this.changePage(activePage)} />
            </Row>
          </div>
          <br></br>
        </ContentWrapper>
      </>
    );
  }
}

export default withRouter(ShipmentTracking);
